export default __webpack_public_path__ + "static/media/G0570.34I-26321_-17333_0.1666265340000.0bb62d3a.jpg";